import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { Shield } from 'images'

import './MiniHeader.css'

class MiniHeader extends PureComponent {
  renderCards() {
    const { localBlue, localGreen, localRed, localYellow, visitorBlue, visitorGreen, visitorRed, visitorYellow } =
      this.props

    if (
      !localBlue &&
      !localGreen &&
      !localRed &&
      !localYellow &&
      !visitorBlue &&
      !visitorGreen &&
      !visitorRed &&
      !visitorYellow
    ) {
      return null
    }

    return (
      <tr>
        <td className="MatchMiniHeader-score-cards" colSpan={3}>
          {localRed || visitorRed ? (
            <span className={classnames('red', !localRed && 'not-card')}>{localRed || '-'}</span>
          ) : null}
          {localYellow || visitorYellow ? (
            <span className={classnames('yellow', !localYellow && 'not-card')}>{localYellow || '-'}</span>
          ) : null}
          {localBlue || visitorBlue ? (
            <span className={classnames('blue', !localBlue && 'not-card')}>{localBlue || '-'}</span>
          ) : null}
          {localGreen || visitorGreen ? (
            <span className={classnames('green', !localGreen && 'not-card')}>{localGreen || '-'}</span>
          ) : null}
          {' ~ '}
          {localGreen || visitorGreen ? (
            <span className={classnames('green', !visitorGreen && 'not-card')}>{visitorGreen || '-'}</span>
          ) : null}
          {localBlue || visitorBlue ? (
            <span className={classnames('blue', !visitorBlue && 'not-card')}>{visitorBlue || '-'}</span>
          ) : null}
          {localYellow || visitorYellow ? (
            <span className={classnames('yellow', !visitorYellow && 'not-card')}>{visitorYellow || '-'}</span>
          ) : null}
          {localRed || visitorRed ? (
            <span className={classnames('red', !visitorRed && 'not-card')}>{visitorRed || '-'}</span>
          ) : null}
        </td>
      </tr>
    )
  }

  renderScore() {
    const {
      bothLose,
      localDefinitionScore,
      localScore,
      localWalkover,
      visitorDefinitionScore,
      visitorScore,
      visitorWalkover,
    } = this.props

    if (bothLose) {
      return <div className="MatchMiniHeader-score-score">pierden</div>
    }

    if (
      localDefinitionScore === null &&
      localScore === null &&
      visitorDefinitionScore === null &&
      visitorScore === null
    ) {
      return null
    }

    return (
      <div className="MatchMiniHeader-score-score">
        {`${localWalkover ? 'W' : localScore} ~ ${visitorWalkover ? 'W' : visitorScore}`}
        {(!!localDefinitionScore || !!visitorDefinitionScore) && (
          <sup>{`(${localDefinitionScore}) ~ (${visitorDefinitionScore})`}</sup>
        )}
      </div>
    )
  }

  render() {
    const { className, compact, local, size, status, visitor } = this.props

    return (
      <table className={classnames('MatchMiniHeader', className, size)}>
        <tbody>
          <tr>
            {!compact && !!local && (
              <td className="MatchMiniHeader-local" rowSpan={2}>
                <h3 className="MatchMiniHeader__name">{local.nickname}</h3>
              </td>
            )}
            <td className="MatchMiniHeader-local-avatar">{!!local && <Shield size="2em" src={local.avatar} />}</td>
            <td className={`MatchMiniHeader-score match ${status}`}>{this.renderScore()}</td>
            <td className="MatchMiniHeader-visitor-avatar">
              {!!visitor && <Shield size="2em" src={visitor.avatar} />}
            </td>
            {!compact && !!visitor && (
              <td className="MatchMiniHeader-visitor" rowSpan={2}>
                <h3 className="MatchMiniHeader__name">{visitor.nickname}</h3>
              </td>
            )}
          </tr>
          {this.renderCards()}
        </tbody>
      </table>
    )
  }
}

MiniHeader.propTypes = {
  bothLose: PropTypes.bool,
  className: PropTypes.string,
  compact: PropTypes.bool,
  local: PropTypes.object,
  localBlue: PropTypes.number,
  localDefinitionScore: PropTypes.number,
  localGreen: PropTypes.number,
  localRed: PropTypes.number,
  localScore: PropTypes.number,
  localWalkover: PropTypes.bool,
  localYellow: PropTypes.number,
  size: PropTypes.oneOf(['mini', 'small', 'large', 'big']),
  status: PropTypes.string,
  visitor: PropTypes.object,
  visitorBlue: PropTypes.number,
  visitorDefinitionScore: PropTypes.number,
  visitorGreen: PropTypes.number,
  visitorRed: PropTypes.number,
  visitorScore: PropTypes.number,
  visitorWalkover: PropTypes.bool,
  visitorYellow: PropTypes.number,
}

MiniHeader.defaultProps = {
  bothLose: false,
  className: null,
  compact: false,
  local: null,
  localBlue: null,
  localDefinitionScore: null,
  localGreen: null,
  localRed: null,
  localScore: null,
  localWalkover: false,
  localYellow: null,
  size: 'small',
  status: '',
  visitor: null,
  visitorBlue: null,
  visitorDefinitionScore: null,
  visitorGreen: null,
  visitorRed: null,
  visitorScore: null,
  visitorWalkover: false,
  visitorYellow: null,
}

export default MiniHeader
